import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailTypeName'
})
export class EmailTypeNamePipe implements PipeTransform {
  private readonly types = {
    sendNotificationPushFromTracking: "Notificaciones de seguimiento del servicio",
    reportBatchDelayedCargos: "Reporte servicios retrasados",
    tracking: "Seguimiento de servicios",
    generateManifest: "Error en la generación del manifiesto",
    applications: "Postulaciones",
    accounting: "Contabilidad",
    reportBatchFastPayment: "Reporte pronto pago",
    confirmedLicensePlate: "Asignación de vehículos",
    deleteCargoNotification: "Eliminar servicios con pagos",
    cargoImport: "Reporte de importaciones",
    cargoExport: "Reporte de exportaciones",
  };

  transform(value: any, ...args: any[]): any {
    return this.types[value] ? this.types[value] : value;
  }

}
